import script from "./VType.vue?vue&type=script&lang=ts&setup=true"
export * from "./VType.vue?vue&type=script&lang=ts&setup=true"

import "./VType.vue?vue&type=style&index=0&id=b9bcab78&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9bcab78"]])

export default __exports__